import { Checkbox, TableNumber } from "components"
import { ValidationSchemaType } from "../utils"
import { useContext } from "react"
import { DeleteContext } from "pages/Setup/contexts"
import { Update } from "./Update"
import { Delete } from "./Delete"

type pagination = {
    page: number,
    limit: number,
    size: number,
    total: number
}

export function ListItem(props: {
    dataList: ValidationSchemaType,
    pagination: pagination,
    index: number,
    refetch: () => void
}) {

    const { toggleDeleteData, value } = useContext(DeleteContext)

    return (
        <tr key={props.dataList.mr_group_id}>
            <td>
                {TableNumber({
                    dataLength: props.pagination.size,
                    pageCurrent: props.pagination.page,
                    index: props.index,
                    limit: props.pagination.limit,
                    totalData: props.pagination.total
                })}
            </td>
            <td className="w-[1px]">
                <Checkbox
                    value={Boolean(value.find(val => val === props.dataList.mr_group_id))}
                    onClick={() => toggleDeleteData(props.dataList.mr_group_id!)}
                />
            </td>
            <td>{props.dataList.mr_group_code}</td>
            <td>{props.dataList.mr_group_name}</td>
            <td>{props.dataList.description}</td>
            <td>
                <Update dataList={props.dataList} refetch={props.refetch} />
                <Delete dataList={props.dataList} refetch={props.refetch} />
            </td>
        </tr>
    )
}